import React from 'react'
import ShowIcon from '../../../Common/svg/showIcon'
import axios from 'axios';
import { toast } from 'react-toastify';
import DownloadFile from '../../../Common/svg/downloadfile';

const CuriorAttachments = ({attachments}) => {
const handleDownload = async (url, fileName) => {

  try {
    const response = await axios.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([response.data]);
    const link = document.createElement("a");

    link.href = window.URL.createObjectURL(blob);
    link.download = fileName || "file";

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(link.href);
  } catch (err) {
   toast.error(`${err?.response?.data?.message}`)
  }
}
  return (
  <div className="table-responsive" dir="rtl">
              <div className="d-flex justify-content-between">
                  <h5 className='fw-bold'>الوثائق </h5>
         
              </div>  
            
            <table className="table align-middle">   
              <thead className="bg-light">
                <tr>
                  <th>نوع الوثيقة </th>
                  <th>تاريخ الإضافة</th>
                  <th>الإجراءات</th>
                 
                </tr>
              </thead>
      
              <tbody>
                 {attachments.map((attach)=>( <tr key={attach.id}>
                    <td className=' fw-bold'>{attach.name}</td>
                    <td>{attach.created_at}</td>
                    <td>
                      <div className='d-flex gap-2'>
                        <a className='btn' target='_blank' href={attach.url}  >
                          <ShowIcon/>
                        </a>
                          <button className='btn'  onClick={()=>handleDownload(attach.url,attach.name)} >
                          <DownloadFile/>
                        </button>
                      </div>
                    </td>
                  </tr>))}
              </tbody>
            </table>
          </div>
  )   
}

export default CuriorAttachments